<template>
  <transition name="slide">
    <div
      v-if="frameSrc"
      :class="[
        'fixed bottom-8 left-8 rounded-md p-2 bg-gray-700/75 dark border-transparent border-2 hover:border-gray-700/90 transition-colors',
        zIndexClass
      ]"
      @mouseover="stopTimer"
      @mouseout="startTimer"
    >
      <u-button
        v-if="file"
        class="absolute right-1 top-1"
        color="charcoal"
        variant="ghost"
        size="xs"
        icon="i-ri-external-link-line"
        @click="emit('open-file', {file})"
      />
      <div class="text-white font-semibold pb-1">Frame Saved</div>
      <img
        :src="frameSrc"
        :class="isPortrait ? 'h-96' : 'w-96'"
      >
    </div>
  </transition>
</template>

<script setup>
  const props = defineProps({
    frameSrc: {
      type: String,
      default: ''
    },
    isPortrait: {
      type: Boolean,
      default: false
    },
    zIndexClass: {
      type: String,
      default: 'z-[2000]'
    },
    file: Object,
    hideDelayMs: {
      type: Number,
      default: 5_000
    }
  });

  const emit = defineEmits(['update:frameSrc', 'open-file']);

  let timer = null;

  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function stopTimer() {
    clearTimer();
  }

  function startTimer() {
    clearTimer();
    timer = setTimeout(() => {
      emit('update:frameSrc', '');
    }, props.hideDelayMs);
  }

  watch(() => props.frameSrc, (newVal) => {
    clearTimer();

    if (newVal) {
      startTimer();
    }
  });

  onUnmounted(() => {
    clearTimer();
  });
</script>

<style scoped lang="scss">
  .slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
  }

  .slide-enter-from {
    transform: translateX(-100px);
    opacity: 0;
  }

  .slide-enter-to {
    transform: translateX(0);
    opacity: 1;
  }

  .slide-leave-from {
    transform: translateX(0);
    opacity: 1;
  }

  .slide-leave-to {
    transform: translateX(-100px);
    opacity: 0;
  }
</style>
